import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SubmissionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SubmissionSVG;
